/**
 * Зеркало tenders/topup_pricing.py на back (превью до ответа quote).
 */
const TOPUP_RATE_TIERS = [
  [10000, 0.77],
  [5000, 0.79],
  [1000, 0.82],
  [100, 0.85],
]

export const TOPUP_MIN_TOKENS = 100
export const TOPUP_MAX_TOKENS = 100000
export const TOPUP_STEP = 100
export const TOPUP_DEFAULT_AMOUNT = 1000

export function topupRateRubPerToken(tokens) {
  const n = Number(tokens) || 0
  for (const [minTokens, rate] of TOPUP_RATE_TIERS) {
    if (n >= minTokens) return rate
  }
  return TOPUP_RATE_TIERS[TOPUP_RATE_TIERS.length - 1][1]
}

export function topupPriceRub(tokens) {
  const n = Number(tokens) || 0
  return Math.ceil(n * topupRateRubPerToken(n))
}

export function normalizeTopupTokens(raw) {
  const value = parseInt(String(raw), 10)
  if (!Number.isFinite(value)) {
    return { tokens: null, error: 'Укажите целое число токенов.' }
  }
  if (value < TOPUP_MIN_TOKENS || value > TOPUP_MAX_TOKENS) {
    return { tokens: null, error: `Докупка от ${TOPUP_MIN_TOKENS} до ${TOPUP_MAX_TOKENS} токенов.` }
  }
  if (value % TOPUP_STEP !== 0) {
    return { tokens: null, error: `Сумма должна быть кратна ${TOPUP_STEP}.` }
  }
  return { tokens: value, error: null }
}

export function topupQuotePreview(tokens) {
  const { tokens: normalized, error } = normalizeTopupTokens(tokens)
  if (error) return { error }
  return {
    tokens: normalized,
    price_rub: topupPriceRub(normalized),
    rub_per_token: topupRateRubPerToken(normalized),
  }
}
